
import List from "./components/List.vue";
import {
  flatTreeData,
  findParentElements,
  getBreadList,
} from "~/utils/index.js";
export default {
  asyncData({ app, route, store }) {
    const db = app.$websiteDataHelper;
    const pageBannerbg =
      encodeURI(db.getMenuItemBanner("news")) ||
      "/img/knowledge-page-banner.png";
    const routeId = route.meta[0].nodeid;

    const categories = store.state.menu.filter(
      item => item.path === "/products",
    )[0].children;
    const hotProducts = db.hotProducts.slice(0, 3);

    const pageSize = 12;
    const currentPage = route.meta[0].page || 1;
    const { list = [], count = 0 } = app.$websiteDataHelper.getList(
      "news",
      routeId,
      currentPage,
      pageSize,
    );

    const menus = store.state.menu.filter(m => m.type === "news");
    const currentPath = route.path.split("/")[1];
    const currentVO = app.$websiteDataHelper.getCurrentVO(
      menus,
      `/${currentPath}`,
    );

    const flatArray = flatTreeData(menus);
    const breadList = findParentElements(routeId, flatArray);
    return {
      banner: pageBannerbg,
      title: (currentVO?.name_ch || "news").toUpperCase().replace(/-/g, " "),
      menu: categories,
      total: count,
      hotProducts,
      currentPage,
      pageData: list,
      pageSize,
      customList: breadList,
      currentVO,
    };
  },
  head() {
    const { path, meta } = this.$route;
    const { menu, baseJsonLd } = this.$store.state.jsonLd;
    const siteUrl = baseJsonLd.url;
    const breadList = getBreadList(menu, this.currentVO, 1);

    const jsonld = {
      ...baseJsonLd,
      name: meta?.title,
      description: meta?.description,
      keywords: meta?.keywords,
      url: new URL(path, siteUrl).toString(),
    };

    return {
      script: [
        {
          type: "application/ld+json",
          json: [
            jsonld,
            {
              "@context": "https://schema.org",
              "@type": "BreadcrumbList",
              itemListElement: breadList,
            },
          ],
        },
      ],
    };
  },
  components: { List },
};
